import { render, staticRenderFns } from "./Audience.vue?vue&type=template&id=e20eb7c8&"
import script from "./Audience.vue?vue&type=script&lang=js&"
export * from "./Audience.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports